export const locales = [
  {value: 'en', name: 'English'},
  {value: 'de', name: 'German'},
  {value: 'fr', name: 'French'},
  {value: 'it', name: 'Italian'},
  {value: 'es', name: 'Spanish'}
]

export const gameLocales = [
  { value: 'en', name: 'English' },
  { value: 'de', name: 'German' },
  { value: 'fr', name: 'French' },
  { value: 'it', name: 'Italian' },
  { value: 'es', name: 'Spanish' },
  { value: 'nl', name: 'Dutch' },
  { value: 'br', name: 'Brazilian Portuguese' },
  { value: 'tr', name: 'Turkish' },
  { value: 'vi', name: 'Vietnamese' },
  { value: 'th', name: 'Thai' },
  { value: 'pl', name: 'Polish' }
];
